<template>
  <div class="learning-progress">
    <div class="message-info">
      <img
        class="avatar"
        src="@/assets/icons/xxjd.png"
        alt="AI"
      />
      <div class="resource-title">学习进度</div>
    </div>
    <!-- 遍历 currentData.nodes 渲染每个章节 -->
    <div class="section" v-for="(node, index) in currentData.nodes" :key="index" @click="openModal(node)">
      <div class="section-content">
        <div class="section-header">
          <span class="icon icon-book"></span>
          <!-- 显示章节标题，截断过长内容并添加 title 属性 -->
          <span class="chapter-title" :title="node.text">第{{index+1}}章 {{ truncateText(node.text, 20) }}</span>
          <!-- 模拟进度百分比 -->
          <span class="progress-percent">{{ getRandomProgress() }}%</span>
        </div>
        <!-- 如果章节有子节点，遍历渲染子节点 -->
        <ul class="sub-list" v-if="node.children && node.children.length > 0">
          <li class="sub-item" v-for="(child, childIndex) in node.children" :key="childIndex">
            <!-- 显示子节点标题，截断过长内容并添加 title 属性 -->
            <span :title="child.text">{{ truncateText(child.text, 25) }}</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 模态框 -->
    <!--<div v-if="showTreeModal" class="modal-overlay" @click="showTreeModal = false">
      <div class="modal-content" @click.stop>
        <h2>{{ selectedNode.text }}</h2>
        <ul>
          <TreeNode :node="selectedNode" />
        </ul>
        <button @click="showTreeModal = false">关闭</button>
      </div>
    </div>-->
    <!-- 弹出层 Modal -->
    <div v-if="showTreeModal" class="modal-mask" @click.self="closeModal">
      <div class="modal-box">
        <div class="modal-header">
          <span class="modal-title">{{ selectedNode.text }}</span>
          <button class="modal-close" @click="closeModal">
            <svg class="close-icon" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="tree-container">
            <ul class="tree-root">
              <tree-node :node="selectedNode" :level="0" :initial-expanded="true"/>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import graphList from '@/assets/data/graphList_combined_chapters.json'

  // 树形节点组件
  const TreeNode = {
    name: 'TreeNode',
    props: {
      node: {
        type: Object,
        required: true
      },
      level: {  // 新增level属性声明
        type: Number,
        default: 0
      },
      initialExpanded: {
        type: Boolean,
        default: false
      }
    },
    template:  `
      <li class="tree-node">
        <div class="node-content" @click="isExpanded = !isExpanded">
        <span class="node-icon">
          <svg v-if="node.children" class="icon-arrow" :class="{ expanded: isExpanded }">
            <path d="M7 10l5 5 5-5z"/>
          </svg>
          <svg v-if="node.children" class="icon-folder" :class="{ expanded: isExpanded }">
            <path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"/>
          </svg>
          <svg v-else class="icon-file">
            <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"/>
          </svg>
        </span>
          <span class="node-text">{{ node.text }}</span>
        </div>
        <transition name="slide">
          <ul v-if="node.children && isExpanded" class="tree-children">
            <tree-node
              v-for="child in node.children"
              :key="child.id"
              :node="child"
              :level="level + 1"
            />
          </ul>
        </transition>
      </li>
    `
  }

  export default {
    name: 'LearningProgress',
    components: {
      TreeNode
    },
    props: {
      currentIndex: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        isExpanded: this.initialExpanded,
        // 存储当前要显示的数据
        currentData: {},
        // 控制模态框显示隐藏
        showTreeModal: false,
        // 选中的节点
        selectedNode: {}
      };
    },
    mounted() {
      // 在组件挂载时根据 currentIndex 获取数据
      this.currentData = graphList[this.currentIndex] || {};
    },
    methods: {
      openModal(node) {
        this.selectedNode = node;
        this.showTreeModal = true;
        document.body.classList.add('no-scroll'); // 禁止背景滚动
      },
      closeModal() {
        this.showTreeModal = false;
        document.body.classList.remove('no-scroll');
      },
      // 生成随机进度百分比
      getRandomProgress() {
        return Math.floor(Math.random() * 101);
      },
      // 截断文本的方法
      truncateText(text, maxLength) {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
      }
    }
  };
</script>

<style scoped>
  /* 学习进度容器样式 */
  .learning-progress {
    margin: 10px;
    background: #ffffff;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    height: auto;
    max-height: 340px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #2d85ed #e0e0e0;
    transition: all 0.3s ease;
  }

  /* 鼠标悬停时容器样式变化 */
  /*.learning-progress:hover {
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
    transform: translateY(-5px);
  }*/

  /* 消息信息区域样式 */
  .message-info {
    display: flex;
    align-items: center;
    gap: 12px;
    /*border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;*/
  }

  /* 头像样式 */
  .avatar {
    width: 25px;
    height: 25px;
    object-fit: cover;
    border-radius: 50%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  /* 资源标题样式 */
  .resource-title {
    font-size: 19px;
    font-weight: 400;
    color: #4d565f;
  }

  /* 章节区域样式 */
  .section {
    padding: 15px;
    border-bottom: 1px solid #e0e0e0;
    transition: background-color 0.3s ease;
    cursor: pointer;
  }

  /* 鼠标悬停时章节区域样式变化 */
  .section:hover {
    background-color: #f0f0f0;
  }

  /* 最后一个章节区域样式 */
  .section:last-child {
    border-bottom: none;
  }

  /* 章节内容区域样式 */
  .section-content {
    display: flex;
    flex-direction: column;
  }

  /* 章节标题区域样式 */
  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  /* 图标样式 */
  .icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }

  /* 书本图标样式 */
  .icon-book {
    width: 18px;
    height: 20px;
    background-image: url('~@/assets/icons/zj.png');
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* 章节标题样式 */
  .chapter-title {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    letter-spacing: 0.3px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    width:180px;
  }

  /* 进度百分比样式 */
  .progress-percent {
    font-size: 14px;
    font-weight: 500;
  }

  /* 子列表样式 */
  .sub-list {
    list-style: none;
    padding-left: 34px;
    margin-top: 0;
  }

  /* 子列表项样式 */
  .sub-item {
    margin-bottom: 8px;
    color: #666;
    font-size: 14px;
    transition: color 0.3s ease;
    position: relative;
  }

  /* 鼠标悬停时子列表项样式变化 */
  .sub-item:hover {
    color: #333;
    transform: translateX(5px);
  }

  /* 子列表项前缀样式 */
  .sub-item::before {
    content: '●';
    color: #4CAF50;
    position: absolute;
    left: -18px;
    top: 3px;
    font-size: 10px;
  }

  /* Modal Styles */
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.3s;
  }

  .modal-box {
    background: #fff;
    border-radius: 12px;
    width: 90%;
    max-width: 800px;
    max-height: 80vh;
    overflow: hidden;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
    transform-origin: center;
    animation: scaleUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .modal-header {
    padding: 20px 24px;
    background: #f8f9fc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e4e7ed;
  }

  .modal-title {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .modal-close {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }

  .close-icon {
    width: 20px;
    height: 20px;
    fill: #909399;
  }

  .modal-close:hover {
    background: #f5f7fa;
  }

  .modal-close:hover .close-icon {
    fill: #f56c6c;
  }

  /* 树形结构样式 */
  .tree-container {
    padding: 16px 24px;
  }

  .tree-root {
    list-style: none;
    padding-left: 0;
    margin: 0;
  }

  .tree-node {
    position: relative;
    padding: 8px 0;
  }

  .tree-node::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    width: 16px;
    height: 1px;
    background: #e4e7ed;
  }

  .node-content {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border-radius: 6px;
    transition: all 0.2s;
  }

  .node-content:hover {
    background: #f5f7fa;
  }

  .node-icon {
    display: flex;
    width: 20px;
    height: 20px;
  }

  .icon-folder {
    fill: #ffb300;
  }

  .icon-file {
    fill: #4c659f;
  }

  .node-text {
    font-size: 14px;
    color: #606266;
    line-height: 1.5;
  }

  .tree-children {
    list-style: none;
    padding-left: 24px;
    margin: 4px 0 0;
    position: relative;
  }

  .tree-children::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 1px;
    background: #e4e7ed;
  }

  .icon-arrow {
    width: 12px;
    height: 12px;
    margin-right: 8px;
    transition: transform 0.2s;
    transform: rotate(-90deg);
  }

  .icon-arrow.expanded {
    transform: rotate(0deg);
  }

  .slide-enter-active, .slide-leave-active {
    transition: all 0.2s ease;
    max-height: 1000px;
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    max-height: 0;
    opacity: 0;
  }

  .tree-children {
    padding-left: 24px;
  }

  .node-content {
    cursor: pointer;
    padding: 6px 0;
    display: flex;
    align-items: center;
  }

  .node-content:hover {
    background: #f5f7fa;
  }

  /* 动画效果 */
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes scaleUp {
    from {
      transform: scale(0.95);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LearningProgress.vue